/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { HighlightComponentDisplay } from "cms/components/components/highlight/display";
import { HighlightComponentEditor } from "cms/components/components/highlight/edit";

const HighlightComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <HighlightComponentDisplay />,
        editComponent: <HighlightComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

HighlightComponent.displayName = "HighlightComponent";
export { HighlightComponent };
